<template>
	<footer class="app-footer">
		<div class="app-footer-service">
			<img
				class="footer-logo"
				:alt="$t('auth-footer-logo-alt')"
				src="@/shared/assets/img/supd-logo-dark.svg"
			/>

			<nav class="app-footer-nav" :aria-label="$t('auth-footer-nav-main')">
				<ul class="footer-nav-list">
					<li>
						<a
							class="footer-nav-link u-link"
							href="https://patientenberatung.de/"
							:title="$t('global-link-opens-in-new-tab')"
							target="_blank"
						>
							{{ $t('auth-footer-homepage') }}
						</a>
					</li>
					<li>
						<a
							class="footer-nav-link u-link"
							href="https://patientenberatung.de/beratungsangebot"
							:title="$t('global-link-opens-in-new-tab')"
							target="_blank"
						>
							{{ $t('auth-footer-advisory-service') }}
						</a>
					</li>
					<li>
						<a
							class="footer-nav-link u-link"
							href="https://patientenberatung.de/weitere-informationen/"
							:title="$t('global-link-opens-in-new-tab')"
							target="_blank"
						>
							{{ $t('auth-footer-information') }}
						</a>
					</li>
					<li>
						<a
							class="footer-nav-link u-link"
							href="https://patientenberatung.de/presse/"
							:title="$t('global-link-opens-in-new-tab')"
							target="_blank"
						>
							{{ $t('auth-footer-press') }}
						</a>
					</li>
					<li>
						<a
							class="footer-nav-link u-link"
							href="https://stiftung-unabhaengige-patientenberatung.jobs.personio.de/"
							:title="$t('global-link-opens-in-new-tab')"
							target="_blank"
						>
							{{ $t('auth-footer-careers') }}
						</a>
					</li>
					<li>
						<a
							class="footer-nav-link u-link"
							href="https://patientenberatung.de/ueber-uns/"
							:title="$t('global-link-opens-in-new-tab')"
							target="_blank"
						>
							{{ $t('auth-footer-about-us') }}
						</a>
					</li>
				</ul>
			</nav>

			<nav class="app-footer-nav" :aria-label="$t('auth-footer-nav-service')">
				<ul class="footer-legal-links">
					<li class="footer-legal-link">
						<a
							class="u-link"
							href="https://patientenberatung.de/impressum/"
							:title="$t('global-link-opens-in-new-tab')"
							target="_blank"
						>
							{{ $t('auth-footer-imprint') }}
						</a>
					</li>
					<li class="footer-legal-link">
						<a
							class="u-link"
							href="https://patientenberatung.de/datenschutz/"
							:title="$t('global-link-opens-in-new-tab')"
							target="_blank"
						>
							{{ $t('auth-footer-data-privacy') }}
						</a>
					</li>
					<li class="footer-legal-link">
						<a
							class="u-link"
							href="https://patientenberatung.de/erklaerung-zur-barrierefreiheit/"
							:title="$t('global-link-opens-in-new-tab')"
							target="_blank"
						>
							{{ $t('auth-footer-accessibility') }}
						</a>
					</li>
				</ul>
			</nav>
		</div>
	</footer>

	<div class="footer-copyright u-list u-list--md">
		<span>
			{{ $t('auth-footer-copyright', { date: new Date() }) }}
		</span>
		<figure>
			<a
				href="https://report.bitvtest.de/f199cdf5-0087-454b-bd21-157b3d412000.html"
				target="_blank"
				rel="noreferrer noopener"
			>
				<img
					class="footer-bitv-img"
					decoding="async"
					width="136"
					src="@/shared/assets/img/bik-bitv-konform.svg"
					:alt="$t('auth-footer-bitv-img-alt')"
					:title="$t('auth-footer-bitv-img-title')"
				/>
			</a>
		</figure>
	</div>
</template>

<style scoped>
.app-footer {
	--footer-logo-max-width: 20rem;

	background-color: var(--c-dark-green-800);
	color: var(--c-white);
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	gap: var(--size-40);
	inline-size: 100%;
	justify-content: space-between;
	padding-block: var(--auth-footer-edge-block-spacing);
	padding-inline: var(--auth-footer-edge-inline-spacing);

	:focus-visible {
		outline-color: var(--c-white);
	}
}

.app-footer-nav {
	display: flex;
	flex-direction: column;
	gap: var(--size-40);
}

.app-footer-service {
	align-items: center;
	display: flex;
	flex-direction: column;
	row-gap: var(--size-40);
}

.footer-nav-list {
	column-gap: var(--size-40);
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	list-style: none;
	row-gap: var(--size-24);
	text-align: center;
}

.footer-nav-link {
	font: var(--type-body-m-medium);
}

.footer-logo {
	inline-size: 100%;
	max-inline-size: var(--footer-logo-max-width);
}

.footer-legal-links {
	display: flex;
	flex-wrap: wrap;
	font: var(--type-body-s);
	justify-content: center;
	list-style: none;
}

.footer-legal-link {
	&:not(:last-child)::after {
		align-self: center;
		block-size: 0.875rem;
		content: '|';
		inline-size: var(--size-1);
		padding-inline: var(--size-8);
	}
}

.footer-copyright {
	background-color: var(--c-white);
	font: var(--type-body-s);
	justify-content: center;
	padding: var(--size-16);
}

.footer-bitv-img {
	object-fit: cover;
}

@media print {
	.app-footer {
		display: none !important;
	}
}
</style>
